import { Component, OnInit } from '@angular/core';
import {TranslationService} from "../../../services/translation.service";

@Component({
  selector: 'app-instruction',
  templateUrl: './instruction.component.html',
  styleUrls: ['./instruction.component.css']
})
export class InstructionComponent implements OnInit {

  currentLang='ru';

  constructor(
      private translateService: TranslationService
  ) { }

  ngOnInit() {
    this.currentLang = this.translateService.getCurrentLanguage();
  }

}
